import { ProjectFromAPI } from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

type ExistingMotionPayload = {
  objectID: string; // can be pulled from projectRecord
  existingJobID: string;
  existingVariationNumber: number;
  trimStart?: number;
  trimEnd?: number;
  sequenceNumber?: number;
  favoriteNewJob?: boolean;
  hideFromHistory?: boolean;
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postProjectExistingMotion(
  projectID: string,
  props: ExistingMotionPayload,
) {
  const { data, error } = await apiRequest<{
    project: ProjectFromAPI;
  }>('mogen-orchestration', `/v2/projects/${projectID}/existingMotion`, {
    method: 'POST',
    body: JSON.stringify(props),
  });

  return {
    data: data ? transformProjectResponse(data.project) : undefined,
    error,
  };
}
